import '../style/syncfusion27.css';
import { license } from '../license';

license();

export { Dialog, DialogComponent } from '@syncfusion/ej2-react-popups';
export type { AnimationSettingsModel, BeforeOpenEventArgs, PositionDataModel } from '@syncfusion/ej2-react-popups';

export {
  HtmlEditor,
  Inject,
  Link,
  NodeSelection,
  QuickToolbar,
  RichTextEditorComponent,
  Table,
  Toolbar,
  PasteCleanup,
} from '@syncfusion/ej2-react-richtexteditor';
export type { ActionBeginEventArgs, IFormatter, PasteCleanupSettingsModel } from '@syncfusion/ej2-react-richtexteditor';
